import { render, staticRenderFns } from "./21.vue?vue&type=template&id=01e3ab04&scoped=true&"
var script = {}
import style0 from "./21.vue?vue&type=style&index=0&id=01e3ab04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e3ab04",
  null
  
)

export default component.exports